import { Emblem } from "./Emblem";

export const DiffrentiaBody = () => {
    return (
        <>
            <div
                className="pb-3 diffbg"
                style={{
                    backgroundImage:
                        "url(../../images/diffrentia/diffbackground.jpg)",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundAttachment: "fixed",
                    backgroundRepeat: "no-repeat",
                    paddingTop: "2rem",
                    minHeight: "100vh",
                }}
            >
                <div className="container">
                    <div className="d-flex justify-content-center align-items-center">
                        <Emblem />
                    </div>
                    <div className="container">
                        <div className="text-center"></div>
                        <div className="p-2 mt-3">
                            <a href="https://play.google.com/store/apps/details?id=com.DragonshiftyStudios.Diffrentia">
                                <div className="text-center">
                                    <img
                                        src="/images/google-play-badge.png"
                                        alt=""
                                    />
                                </div>
                            </a>
                        </div>
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-2 mt-2">
                            {/* Column One */}
                            <div className="col p-3 ">
                                <p className="d-flex justify-content-center text-white cinzel-decorative-regular px-3">
                                    Diffrentia is an old-fashioned-style card
                                    game that is easy to pick up and gives you
                                    strategic options, plus a weekly goal - to
                                    win for your chosen clan.
                                </p>
                                <p className="d-flex justify-content-center  text-white cinzel-decorative-regular px-3">
                                    Games typically last about four minutes,
                                    followed by a score commentary with a
                                    healthy dose of sarcasm or praise, depending
                                    on the outcome.
                                </p>
                            </div>
                            {/* Column Two */}
                            <div className="col p-3">
                                <p className="d-flex justify-content-center  text-white cinzel-decorative-regular px-3">
                                    Choose your favourite clan to battle for out
                                    of Cat, Fox, Falcon, and Dragon then gain
                                    the most points for your clan before 6pm
                                    (local time) every Sunday to win.
                                </p>
                                <p className="d-flex justify-content-center  text-white cinzel-decorative-regular px-3">
                                    Check in any time to see how your clan is
                                    doing with the weekly battle commentary
                                    system (slightly less sarcastic).
                                </p>
                            </div>

                            <div className="col p-3 img-fluid d-flex justify-content-center position-relative">
                                <img
                                    className=" "
                                    src="../images/diffrentia/Falcon300.png"
                                    alt="Falcon"
                                />
                                <p className="position-absolute top-50 start-50 translate-middle text-center text-white cinzel-decorative-regular">
                                    "Like a leaf on the wind."
                                </p>
                            </div>

                            <div className="col p-3 img-fluid d-flex justify-content-center position-relative">
                                <img
                                    className=" "
                                    src="../images/diffrentia/Fox300.png"
                                    alt="Fox"
                                />
                                <p className="position-absolute top-50 start-50 translate-middle text-center text-white cinzel-decorative-regular">
                                    "This reminds me of a funny story, but you
                                    wouldn't want to hear it right now."
                                </p>
                            </div>
                            <div className="col p-3 img-fluid d-flex justify-content-center position-relative">
                                <img
                                    className=" "
                                    src="../images/diffrentia/Dragon300.png"
                                    alt="Dragon"
                                />
                                <p className="position-absolute top-50 start-50 translate-middle text-center text-white cinzel-decorative-regular">
                                    "Unexpected win in the scoring area..."
                                </p>
                            </div>
                            <div className="col p-3 img-fluid d-flex justify-content-center position-relative">
                                <img
                                    className=" "
                                    src="../images/diffrentia/Cat300.png"
                                    alt="Cat"
                                />
                                <p className="position-absolute top-50 start-50 translate-middle text-center text-white cinzel-decorative-regular">
                                    "You showed up. That's good, isn't it?!"
                                </p>
                            </div>
                        </div>
                        <div className="container p-sm-0 p-lg-5">
                            <div className="iframe-container">
                                <iframe
                                    className="border border-3"
                                    src="https://www.youtube-nocookie.com/embed/03R1yHnLjQc?si=bvu2J-TZzV6xY56M"
                                    title="YouTube video player"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
